module.exports = __webpack_public_path__ + "static/media/ic-arrow-down.70e88779.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-arrow-down.svg
// module id = 590
// module chunks = 14